export const statusProps = {
  basename: "/status",
};
